import { render } from "./TeamMemberModal.vue?vue&type=template&id=1c1b7075&ts=true"
import script from "./TeamMemberModal.vue?vue&type=script&lang=ts"
export * from "./TeamMemberModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__